import { VibeLogger } from '@aifest/shared'

// ブラウザ環境用のカスタムログ設定
const logConfig = {
  appName: 'earth-web',
  environment: import.meta.env.MODE,
  enableConsole: true
}

export const logger = new VibeLogger(logConfig)

// UIイベント用のカスタムロガー
export const uiLogger = {
  appStarted: () => {
    logger.step('Application Started', {
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      context: { type: 'ui_event', category: 'lifecycle' }
    })
  },
  
  actionClicked: (action: string, energy: number) => {
    logger.process('Action Clicked', {
      action,
      energyAvailable: energy,
      timestamp: new Date().toISOString(),
      context: { type: 'ui_event', category: 'user_interaction' }
    })
  },
  
  worldUpdated: (worldAge: number, isAlive: boolean) => {
    logger.info('World Updated', {
      worldAge,
      isAlive,
      timestamp: new Date().toISOString(),
      context: { type: 'ui_event', category: 'state_update' }
    })
  },
  
  apiCall: (endpoint: string, method: string, duration: number) => {
    logger.debug('API Call', {
      endpoint,
      method,
      duration,
      timestamp: new Date().toISOString(),
      context: { type: 'network', category: 'api' }
    })
  },
  
  renderPerformance: (fps: number, renderTime: number) => {
    logger.debug('Render Performance', {
      fps,
      renderTime,
      timestamp: new Date().toISOString(),
      context: { type: 'performance', category: 'rendering' }
    })
  },
  
  error: (error: Error, context?: any) => {
    logger.error('UI Error', {
      message: error.message,
      stack: error.stack,
      context,
      timestamp: new Date().toISOString()
    })
  },
  
  todo: (task: string, priority: 'low' | 'medium' | 'high' = 'medium') => {
    logger.todo(task, {
      priority,
      timestamp: new Date().toISOString(),
      context: { type: 'development', category: 'todo' }
    })
  }
}